import React from "react";
import styles from '../../css/Part3.module.css';

function LoyaltyProgram() {
  return (
    <section className={styles.container} id="section_M20">
      <div className={styles.content}>
        <div className={styles.imageColumn}>
          <img  
            src="images/background/image 71.png" 
            className={styles.loyaltyImage} 
            alt="M2O Loyalty Program illustration"
          />
        </div>
        <div className={styles.textColumn}>
          <div className={styles.textContent}>
            <h1 className={styles.mainHeading}>
              Let's Share, They Spend, We Earn
            </h1>
            <p className={styles.description}>
              FoneApp users that have been earning from Many-To-One (M2O) Loyalty Program every month.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LoyaltyProgram;